import React from 'react';
import { Button } from 'antd';
import '../Orders.scss';
import { ORDER_STATUSES } from '../../../constants';

const forbiddenStatuses = [ORDER_STATUSES.EXPECTED, ORDER_STATUSES.IN_TRANSIT, ORDER_STATUSES.REJECTED];
export const BulkStatus = ({ onSelect }) => {
  const statuses = Object.entries(ORDER_STATUSES)
    .filter(([, v]) => !forbiddenStatuses.includes(v))
    .map(([k]) => k);
  return (
    <div className="buttons">
      {statuses.map((s) => (
        <Button type="link" key={s} onClick={() => onSelect({ status: s })}>
          {s.replace(/_/g, ' ')}
        </Button>
      ))}
    </div>
  );
};
